webpackJsonp([10],{

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("188c66ab", content, true, {});

/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".note-body>ol>li[data-v-23926567]{margin-bottom:40px}.btn-send-request[data-v-23926567]{width:150px!important;max-width:150px}.q-count[data-v-23926567]{top:99%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:20px;font-size:1.3rem}.progress[data-v-23926567]{background-color:rgba(82,82,82,.05)}.bg-progress[data-v-23926567]{background-color:rgba(41,185,25,.9)}.test-body[data-v-23926567]{max-height:unset}.vb-body[data-v-23926567]{min-height:46rem}.vb-body p[data-v-23926567]{font-size:1.2rem!important;line-height:1.6}.form-control[data-v-23926567]{width:auto;display:inline}.help-words li[data-v-23926567]{display:inline;list-style-type:disc;color:#557c84}.help-words li+li[data-v-23926567]:before{content:\" \\B7   \"}.form-check-input[data-v-23926567]{position:relative}", "", {"version":3,"sources":["F:/myugfront/src/pages/lab-unit.vue"],"names":[],"mappings":"AACA,kCACI,kBAAoB,CACvB,AACD,mCACI,sBAAwB,AACxB,eAAiB,CACpB,AACD,0BACI,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,+BAAiC,AACzC,YAAa,AACb,gBAAkB,CACrB,AACD,2BACI,mCAAoC,CACvC,AACD,8BACI,mCAAuC,CAC1C,AACD,4BACI,gBAAkB,CACrB,AACD,0BACI,gBAAkB,CACrB,AACD,4BACI,2BAA6B,AAC7B,eAAiB,CACpB,AACD,+BACI,WAAY,AACZ,cAAgB,CACnB,AACD,gCACI,eAAgB,AAChB,qBAAsB,AACtB,aAAe,CAClB,AACD,0CACE,iBAAe,CAChB,AACD,mCACI,iBAAmB,CACtB","file":"lab-unit.vue","sourcesContent":["\n.note-body > ol > li[data-v-23926567] {\n    margin-bottom: 40px;\n}\n.btn-send-request[data-v-23926567]{\n    width: 150px !important;\n    max-width: 150px;\n}\n.q-count[data-v-23926567]{\n    top: 99%;\n    left: 50%;\n    -webkit-transform: translate(-50%,-50% );\n            transform: translate(-50%,-50% );\n    height: 20px;\n    font-size: 1.3rem;\n}\n.progress[data-v-23926567]{\n    background-color: rgba(82,82,82,.05)\n}\n.bg-progress[data-v-23926567]{\n    background-color: rgba(41, 185, 25,.9);\n}\n.test-body[data-v-23926567]{\n    max-height: unset;\n}\n.vb-body[data-v-23926567]{\n    min-height: 46rem;\n}\n.vb-body p[data-v-23926567]{\n    font-size: 1.2rem !important;\n    line-height: 1.6;\n}\n.form-control[data-v-23926567]{\n    width: auto;\n    display: inline;\n}\n.help-words li[data-v-23926567]{\n    display: inline;\n    list-style-type: disc;\n    color: #557c84;\n}\n.help-words li + li[data-v-23926567]::before {\n  content: \" · \";\n}\n.form-check-input[data-v-23926567]{\n    position: relative;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instruction_vue__ = __webpack_require__(838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf177986_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instruction_vue__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1114)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf177986"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instruction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf177986_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instruction_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf177986_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instruction_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("ca393f2e", content, true, {});

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"instruction.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lab-instruction"},[_c('h3',{staticClass:"text-center mt-4"},[_vm._v(_vm._s(_vm.$t('lab.instruction.title')))]),_vm._v(" "),_c('p',{staticClass:"link-red text-center mb-0"},[_vm._v(_vm._s(_vm.$t('lab.instruction.warning')))]),_vm._v(" "),_c('div',{staticClass:"note test-body mb-0"},[_c('div',{staticClass:"note-body",domProps:{"innerHTML":_vm._s(_vm.instructionText)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.instructionExercise)}})])])}
var staticRenderFns = []


/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiple_choice_vue__ = __webpack_require__(839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae115b64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiple_choice_vue__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1118)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae115b64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiple_choice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae115b64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiple_choice_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae115b64_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiple_choice_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("5da97084", content, true, {});

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".form-check-label[data-v-ae115b64]{cursor:pointer}.valid label[data-v-ae115b64]{color:#4cff00!important;font-weight:bolder}.invalid label[data-v-ae115b64]{color:#ff000a!important;font-weight:bolder}.vb-body p[data-v-ae115b64]{font-size:1.2rem!important;line-height:1.6}.help-words li[data-v-ae115b64]{display:inline;list-style-type:disc;color:#557c84}.help-words li+li[data-v-ae115b64]:before{content:\" \\B7   \"}.form-check-input[data-v-ae115b64]{position:relative}", "", {"version":3,"sources":["F:/myugfront/src/components/lab/multiple-choice.vue"],"names":[],"mappings":"AACA,mCACE,cAAgB,CACjB,AACD,8BACE,wBAA0B,AAC1B,kBAAoB,CACrB,AACD,gCACE,wBAA0B,AAC1B,kBAAoB,CACrB,AACD,4BACE,2BAA6B,AAC7B,eAAiB,CAClB,AACD,gCACE,eAAgB,AAChB,qBAAsB,AACtB,aAAe,CAChB,AACD,0CACE,iBAAe,CAChB,AACD,mCACE,iBAAmB,CACpB","file":"multiple-choice.vue","sourcesContent":["\n.form-check-label[data-v-ae115b64] {\n  cursor: pointer;\n}\n.valid label[data-v-ae115b64] {\n  color: #4cff00 !important;\n  font-weight: bolder;\n}\n.invalid label[data-v-ae115b64] {\n  color: #ff000a !important;\n  font-weight: bolder;\n}\n.vb-body p[data-v-ae115b64]{\n  font-size: 1.2rem !important;\n  line-height: 1.6;\n}\n.help-words li[data-v-ae115b64]{\n  display: inline;\n  list-style-type: disc;\n  color: #557c84;\n}\n.help-words li + li[data-v-ae115b64]::before {\n  content: \" · \";\n}\n.form-check-input[data-v-ae115b64]{\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.question.text)}}),_vm._v(" "),_c('ol',{attrs:{"type":"a"}},_vm._l((_vm.question.answers),function(answer,$index){return _c('li',[_c('div',{class:['form-check',
                      { valid: _vm.getIfAnswered(_vm.question.questionID) && _vm.isValid(_vm.question.questionID, answer.answerID) },
                      { invalid: _vm.getIfAnswered(_vm.question.questionID) && !_vm.isValid(_vm.question.questionID, answer.answerID) }]},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","disabled":_vm.getIfAnswered(_vm.question.questionID),"name":'multiple-'+_vm.question.questionID,"id":'answer-'+answer.answerID},domProps:{"value":answer.answerID,"checked":_vm.getIfAnswered(_vm.question.questionID) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answerID},on:{"input":function($event){return _vm.handleCheck(_vm.question.questionID, answer.answerID)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'answer-'+answer.answerID}},[_c('span',{domProps:{"innerHTML":_vm._s(answer.answer)}}),_vm._v(" "),(_vm.getIfAnswered(_vm.question.questionID) && _vm.isValid(_vm.question.questionID, answer.answerID) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answerID)?_c('span',{staticClass:"text-uppercase ml-5"},[_vm._v(_vm._s(_vm.$t('lab.correct'))+"!")]):(_vm.getIfAnswered(_vm.question.questionID) && !_vm.isValid(_vm.question.questionID, answer.answerID) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answerID)?_c('span',{staticClass:"text-uppercase ml-5"},[_vm._v(_vm._s(_vm.$t('lab.incorrect'))+"!")]):_vm._e()])])])}),0)])}
var staticRenderFns = []


/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blank_question_vue__ = __webpack_require__(840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2540d38d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blank_question_vue__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1122)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2540d38d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blank_question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2540d38d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blank_question_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2540d38d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blank_question_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1123);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("961b1586", content, true, {});

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".valid[data-v-2540d38d]{border:3px solid #4cff00!important}.invalid[data-v-2540d38d]{border:3px solid #ff000a!important}.text p[data-v-2540d38d]{display:inline;margin:0;padding:0}.vb-body p[data-v-2540d38d]{font-size:1.2rem!important;line-height:1.6}.form-control[data-v-2540d38d]{width:auto!important;display:inline!important;border-color:#557c84}.help-words li[data-v-2540d38d]{display:inline;list-style-type:disc;color:#557c84}.help-words li+li[data-v-2540d38d]:before{content:\" \\B7   \"}", "", {"version":3,"sources":["F:/myugfront/src/components/lab/blank-question.vue"],"names":[],"mappings":"AACA,wBACE,kCAAqC,CACtC,AACD,0BACE,kCAAqC,CACtC,AACD,yBACE,eAAgB,AAChB,SAAU,AACV,SAAW,CACZ,AACD,4BACE,2BAA6B,AAC7B,eAAiB,CAClB,AACD,+BACE,qBAAuB,AACvB,yBAA2B,AAC3B,oBAAsB,CACvB,AACD,gCACE,eAAgB,AAChB,qBAAsB,AACtB,aAAe,CAChB,AACD,0CACE,iBAAe,CAChB","file":"blank-question.vue","sourcesContent":["\n.valid[data-v-2540d38d] {\n  border: 3px solid #4cff00 !important;\n}\n.invalid[data-v-2540d38d] {\n  border: 3px solid #ff000a !important;\n}\n.text p[data-v-2540d38d] {\n  display: inline;\n  margin: 0;\n  padding: 0;\n}\n.vb-body p[data-v-2540d38d]{\n  font-size: 1.2rem !important;\n  line-height: 1.6;\n}\n.form-control[data-v-2540d38d] {\n  width: auto !important;\n  display: inline !important;\n  border-color: #557c84;\n}\n.help-words li[data-v-2540d38d]{\n  display: inline;\n  list-style-type: disc;\n  color: #557c84;\n}\n.help-words li + li[data-v-2540d38d]::before {\n  content: \" · \";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getText()),function(text,$index){return _c('span',{staticClass:"text"},[_c('span',{domProps:{"innerHTML":_vm._s(text)}}),_vm._v(" "),(_vm.getText().length > $index + 1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputs[$index]),expression:"inputs[$index]"}],class:['form-control', { valid: _vm.isValid($index) }, { invalid: !_vm.isValid($index) }],attrs:{"disabled":_vm.getIfAnswered($index),"type":"text"},domProps:{"value":(_vm.inputs[$index])},on:{"change":function($event){return _vm.handleBlur($index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputs, $index, $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.isValid($index))?_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.$t('lab.correct'))+": "+_vm._s(_vm.correctAnswer($index)))]):_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('lab.incorrect'))+"!, "+_vm._s(_vm.$t('lab.correct'))+": "),_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.correctAnswer($index)))]),_c('br')])])}),0)}
var staticRenderFns = []


/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_true_false_vue__ = __webpack_require__(841);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d51b9e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_true_false_vue__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1126)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d51b9e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_true_false_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d51b9e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_true_false_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d51b9e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_true_false_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("c34835a2", content, true, {});

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".form-check-label[data-v-4d51b9e4]{cursor:pointer}.valid label[data-v-4d51b9e4]{color:#4cff00!important;font-weight:bolder}.invalid label[data-v-4d51b9e4]{color:#ff000a!important;font-weight:bolder}.vb-body p[data-v-4d51b9e4]{font-size:1.2rem!important;line-height:1.6}ul[data-v-4d51b9e4]{display:inline}ul li[data-v-4d51b9e4]{display:inline;list-style-type:disc;color:#557c84}ul li+li[data-v-4d51b9e4]:before{content:\"\"}.form-check-input[data-v-4d51b9e4]{position:relative}", "", {"version":3,"sources":["F:/myugfront/src/components/lab/true-false.vue"],"names":[],"mappings":"AACA,mCACE,cAAgB,CACjB,AACD,8BACE,wBAA0B,AAC1B,kBAAoB,CACrB,AACD,gCACE,wBAA0B,AAC1B,kBAAoB,CACrB,AACD,4BACE,2BAA6B,AAC7B,eAAiB,CAClB,AACD,oBACE,cAAgB,CACjB,AACD,uBACE,eAAgB,AAChB,qBAAsB,AACtB,aAAe,CAChB,AACD,iCACE,UAAY,CACb,AACD,mCACE,iBAAmB,CACpB","file":"true-false.vue","sourcesContent":["\n.form-check-label[data-v-4d51b9e4] {\n  cursor: pointer;\n}\n.valid label[data-v-4d51b9e4] {\n  color: #4cff00 !important;\n  font-weight: bolder;\n}\n.invalid label[data-v-4d51b9e4] {\n  color: #ff000a !important;\n  font-weight: bolder;\n}\n.vb-body p[data-v-4d51b9e4]{\n  font-size: 1.2rem !important;\n  line-height: 1.6;\n}\nul[data-v-4d51b9e4] {\n  display: inline;\n}\nul li[data-v-4d51b9e4]{\n  display: inline;\n  list-style-type: disc;\n  color: #557c84;\n}\nul li + li[data-v-4d51b9e4]::before {\n  content: \"\";\n}\n.form-check-input[data-v-4d51b9e4]{\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.question.text)}}),_vm._v(" "),_c('ul',_vm._l((_vm.answers),function(answer){return _c('li',[_c('div',{class:['form-check',
                      { valid: _vm.getIfAnswered(_vm.question.questionID) && _vm.isValid(_vm.question.questionID, answer.answer_id) },
                      { invalid: _vm.getIfAnswered(_vm.question.questionID) && !_vm.isValid(_vm.question.questionID, answer.answer_id) }]},[_c('input',{staticClass:"form-check-input",attrs:{"disabled":_vm.getIfAnswered(_vm.question.questionID),"type":"radio","name":'true-false-'+_vm.question.questionID,"id":'answer-'+answer.answer_id+_vm.question.questionID},domProps:{"checked":_vm.getIfAnswered(_vm.question.questionID) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answer_id,"value":answer.answer_id === 1},on:{"input":function($event){return _vm.handleCheck(_vm.question.questionID, answer.answer_id)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'answer-'+answer.answer_id+_vm.question.questionID}},[_vm._v("\n          "+_vm._s(answer.answer_text)+"\n          "),(_vm.getIfAnswered(_vm.question.questionID) && _vm.isValid(_vm.question.questionID, answer.answer_id) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answer_id)?_c('span',{staticClass:"text-uppercase ml-5"},[_vm._v(_vm._s(_vm.$t('lab.correct'))+"!")]):(_vm.getIfAnswered(_vm.question.questionID) && !_vm.isValid(_vm.question.questionID, answer.answer_id) && _vm.getIfAnswered(_vm.question.questionID).answer_id == answer.answer_id)?_c('span',{staticClass:"text-uppercase ml-5"},[_vm._v(_vm._s(_vm.$t('lab.incorrect'))+"!")]):_vm._e()])])])}),0)])}
var staticRenderFns = []


/***/ }),

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('main',{staticClass:"col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10",attrs:{"role":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-5"},[_c('app-header')],1)]),_vm._v(" "),_c('section',{staticClass:" px-0 mx-0 px-xl-5 mx-xl-5 mb-5 h-100 pb-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 mb-5"},[_c('h2',{staticClass:"text-center mt-5 mt-sm-0"},[_vm._v(_vm._s(_vm.$t('lab.ug-language-lab')))])])]),_vm._v(" "),(_vm.session === null)?_c('div',{staticClass:"row justify-content-center mb-5 text-center"},[(_vm.canSendRequest)?_c('div',{staticClass:"col-12"}):_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("\n                          "+_vm._s(_vm.$t('lab.you-cant-send-request'))+"\n                        ")])])]):(!_vm.session.request_approved_by)?_c('div',{staticClass:"row justify-content-center mb-5 text-center"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('lab.wait-for-confirmation')))])])]):(_vm.finished)?_c('div',{staticClass:"row justify-content-center mb-5 text-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bg-light b-30 shadow-1 p-4 mt-5 pt-5",staticStyle:{"min-height":"42rem"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('lab.already-finished')))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('lab.point'))+": "+_vm._s(_vm.totalPoint))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('lab.finish-date'))+": "+_vm._s(_vm.finishDate))])])])]):(_vm.exercise)?_c('div',{staticClass:"row justify-content-center mb-5"},[_c('div',{staticClass:"col-md-12 mb-5"},[_c('h4',[_vm._v(_vm._s(_vm.$t('lab.total-questions'))+": "+_vm._s(_vm.unit.total_questions))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('lab.correct-answers'))+": "+_vm._s(_vm.session.correct_answers))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('lab.total-points'))+": "+_vm._s(parseFloat(parseFloat(_vm.session.correct_answers).toPrecision(2) / parseFloat(_vm.unit.total_questions)).toPrecision(2)))]),_vm._v(" "),_c('div',{staticClass:"mb-3 mt-2"},[_c('div',{staticClass:"progress position-relative",staticStyle:{"height":"20px"}},[_c('span',{staticClass:"position-absolute q-count"},[_vm._v(_vm._s(_vm.exercise.position)+"/"+_vm._s(_vm.exercise.total_exercises))]),_vm._v(" "),_c('div',{staticClass:"progress-bar bg-progress",style:('width: '+_vm.statusBar+'%'),attrs:{"role":"progressbar","aria-valuenow":_vm.statusBar,"aria-valuemin":"0","aria-valuemax":_vm.exercise.total_exercises}})])]),_vm._v(" "),(_vm.exercise.type)?_c('h4',[_vm._v(_vm._s(_vm.$t('lab.type'))+": "+_vm._s(_vm.exercise.type))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg-light b-30 shadow-1 p-4 mt-5",staticStyle:{"min-height":"42rem"}},[(_vm.exercise.instruction)?_c('instruction',{attrs:{"instruction-text":_vm.exercise.instruction,"instruction-exercise":_vm.exercise.exercise}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"note test-body mb-0"},[(_vm.exercise.audio_link)?_c('div',{staticClass:"audio"},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.exercise.audio_link,"type":"audio/mpeg"}}),_vm._v("\n                                      Your browser does not support the audio element.\n                                    ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"note test-body mb-0"},[_c('div',{staticClass:"note-body "},[_c('ol',{attrs:{"type":"1"}},_vm._l((_vm.exercise.questions),function(question,$index){return _c('li',[(question.type.name === 'Multiple')?_c('multiple-choice',{key:$index,attrs:{"index":$index,"question":question,"validated-answers":_vm.validatedAnswers},on:{"answer":_vm.answerMultiple}}):_vm._e(),_vm._v(" "),(question.type.name === 'Blanks')?_c('blank-question',{key:$index,attrs:{"index":$index,"question":question,"validated-answers":_vm.validatedAnswers},on:{"answer":_vm.answerBlankQuestion}}):_vm._e(),_vm._v(" "),(question.type.name === 'True/False')?_c('true-false',{key:$index,attrs:{"index":$index,"question":question,"validated-answers":_vm.validatedAnswers},on:{"answer":_vm.answerTrueFalse}}):_vm._e()],1)}),0)])]),_vm._v(" "),_c('div',{staticClass:"note-footer text-center"},[_c('button',{staticClass:"btn btn-primary-red-10",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleCheckClick}},[_vm._v(_vm._s(_vm.$t('lab.check')))])])],1)])]):_vm._e()])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lab_unit_vue__ = __webpack_require__(837);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23926567_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lab_unit_vue__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1111)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23926567"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lab_unit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23926567_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lab_unit_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23926567_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lab_unit_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(687)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-565437c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__ = __webpack_require__(678);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: {
    skSidebar: __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__["a" /* default */],
    skNavbarSidebar: __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['sidebarNavItems'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('conversation', ['unreadConversations'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['token']))
});

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-sidebar'
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-sidebar'
});

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb',
  props: ['items']
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(77);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__language_switcher__["a" /* default */],
    SkNavbarHeader: __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__["a" /* default */],
    NavHeaderLg: __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__["a" /* default */],
    NavHeaderMd: __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__["a" /* default */],
    NavHeaderSm: __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['headerMenuTree'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture'])),
  methods: {
    setLocale: function setLocale(locale) {
      __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].locale = locale;
      localStorage.setItem('locale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_item__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__["a" /* default */],
    NotificationItem: __WEBPACK_IMPORTED_MODULE_1__notification_item__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      per_page: 20
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    notifications: 'notifications/notifications',
    loading: 'notifications/loading',
    newNotifications: 'notifications/newNotifications'
  })),
  methods: {
    setSeen: function setSeen(notification) {
      if (!notification.seen_at) {
        this.$store.dispatch('notifications/seen', notification.notificationID).then(function () {
          if (notification.link) window.location.href = notification.link;
        });
      } else if (notification.link) window.location.href = notification.link;
    },
    seeAll: function seeAll() {
      var _this = this;

      this.$store.dispatch('notifications/seeAll').then(function () {
        _this.$store.dispatch('notifications/loadNotifications');

        _this.$store.dispatch('notifications/loadCounts');
      });
    },
    loadNotifications: function loadNotifications() {
      this.$store.dispatch('notifications/loadNotifications', {
        page: this.page,
        per_page: this.per_page
      });
    }
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-item',
  props: ['item'],
  computed: {
    link: function link() {
      return this.item.link || null;
    }
  },
  methods: {
    handleClick: function handleClick($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('seen', this.item);
    }
  }
});

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-header'
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(660);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-lg',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-md',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-sm',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  })),
  methods: {
    setLocale: function setLocale(locale) {
      this.$store.dispatch('language/setLocale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  name: 'page-title'
});

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__ = __webpack_require__(676);
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  components: {
    NavHeader: __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__["a" /* default */]
  }
});

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_title__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb__ = __webpack_require__(675);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-header',
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__breadcrumb__["a" /* default */],
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__page_title__["a" /* default */]
  },
  props: ['pageTitle', 'breadcrumb']
});

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(684)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8eb91f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('tb-skeleton',{attrs:{"aspect-ratio":1,"shape":"circle"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)])])])])}
var staticRenderFns = []


/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"col-12 col-sm-3 col-md-2 col-lg-2 position-fixed sd-bg px-sm-0 px-md-0 px-lg-1 px-xl-3 d-none d-sm-block"},[_c('div',{staticClass:"sidebar flex-nowrap overflow-auto px-0 d-flex align-items-center flex-column h-100 px-md-0 px-lg-1 px-xl-4"},[_c('div',{staticClass:"mb-auto mt-5 "},[(!_vm.user || !_vm.studentPicture)?_c('sk-sidebar'):_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"circle-border "},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":"profile-image"}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4 mb-md-5 mb-lg-0"},[_c('p',{staticClass:"f-p1 mb-2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'fullName')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'speciality')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'studentStatus')))])]),_vm._v(" "),(!_vm.sidebarNavItems || _vm.sidebarNavItems.length === 0)?_c('sk-navbar-sidebar'):_c('ul',{staticClass:"nav flex-column"},_vm._l((_vm.sidebarNavItems),function(navItem){return _c('li',{staticClass:"nav-item"},[(navItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"to":navItem.link}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()]):_c('a',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navItem.link + '&token=' + _vm.token}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()])],1)}),0)],1),_vm._v(" "),_c('div',{staticClass:" d-flex justify-content-center ug-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("635519c8", content, true, {});

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"breadcrumb.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-container  mb-3"},[_c('nav',{attrs:{"aria-label":"breadcrumb d-none d-sm-none d-md-block"}},[_c('ol',{staticClass:"breadcrumb  ml-auto "},_vm._l((_vm.items),function(item){return _c('li',{class:['breadcrumb-item', { active: item.isActive } ]},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3cd26278", content, true, {});

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".no-notifications[data-v-565437c6]{font-weight:700;text-align:center;font-size:14px;min-height:56px}.dropdown-menu[data-v-565437c6]{padding:1.4rem 0 0;min-width:26.5rem}.dropdown-menu-items[data-v-565437c6]{max-height:300px;overflow-y:auto}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar{width:5px;height:5px}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb{background:#c2c2c2;border-radius:5px;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover{background:#c2c2c2;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track{padding-left:1rem;background:#f2f2f2;-webkit-box-shadow:inset 0 0 6px transparent;border-radius:0}", "", {"version":3,"sources":["F:/myugfront/src/components/notifications.vue"],"names":[],"mappings":"AACA,mCACE,gBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,mBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,yDACE,UAAW,AACX,UAAY,CACb,AACD,+DACE,mBAAoB,AACpB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,qEACE,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,+DACE,kBAAmB,AACnB,mBAAoB,AACpB,6CAA8C,AAC9C,eAAiB,CAClB","file":"notifications.vue","sourcesContent":["\n.no-notifications[data-v-565437c6] {\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  min-height: 56px;\n}\n.dropdown-menu[data-v-565437c6] {\n  padding: 1.4rem 0 0 0;\n  min-width: 26.5rem;\n}\n.dropdown-menu-items[data-v-565437c6] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb {\n  background: #c2c2c2;\n  border-radius: 5px;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover {\n  background: #c2c2c2;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track {\n  padding-left: 1rem;\n  background: #f2f2f2;\n  -webkit-box-shadow: inset 0 0 6px transparent;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(690)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76d7dcc1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("5ff169c0", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown-item[data-v-76d7dcc1]{border-radius:0!important}.dropdown-item.unread[data-v-76d7dcc1],.dropdown-item[data-v-76d7dcc1]:hover{font-family:inherit!important;background-color:hsla(0,0%,75%,.1)}.dropdown-item .icon[data-v-76d7dcc1]{display:block;margin-right:1rem;padding:1rem}.dropdown-item .icon img[data-v-76d7dcc1]{width:36px}", "", {"version":3,"sources":["F:/myugfront/src/components/notification-item.vue"],"names":[],"mappings":"AACA,gCACE,yBAA4B,CAC7B,AACD,6EACE,8BAAgC,AAChC,kCAA2C,CAC5C,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,YAAc,CACf,AACD,0CACE,UAAY,CACb","file":"notification-item.vue","sourcesContent":["\n.dropdown-item[data-v-76d7dcc1] {\n  border-radius: 0 !important;\n}\n.dropdown-item[data-v-76d7dcc1]:hover, .dropdown-item.unread[data-v-76d7dcc1] {\n  font-family: inherit !important;\n  background-color: rgba(192, 192, 192, 0.1);\n}\n.dropdown-item .icon[data-v-76d7dcc1] {\n  display: block;\n  margin-right: 1rem;\n  padding: 1rem;\n}\n.dropdown-item .icon img[data-v-76d7dcc1] {\n  width: 36px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[{unread: !_vm.item.seen_at}, 'dropdown-item', 'd-flex'],attrs:{"href":_vm.link},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.item.icon}})]),_vm._v(" "),_c('div',[_c('div',{class:{'font-weight-bold': !_vm.item.seen_at},domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.helpers.getDateDifference(_vm.item.created_at)))])])])}
var staticRenderFns = []


/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown header-notify pl-4"},[_c('a',{staticClass:"nav-link position-relative cursor-pointer",attrs:{"data-toggle":"dropdown"},on:{"click":_vm.loadNotifications}},[(_vm.newNotifications > 0)?_c('span',[_c('span',{staticClass:"pulse"}),_vm._v(" "),_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notification-recieved.png","alt":"notifications"}})]):_c('span',[_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notifications.png","alt":"notifications"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow animated"},[(_vm.loading)?_c('sk-list',{attrs:{"height":0.2,"items-count":4}}):_c('div',{staticClass:"dropdown-menu-items"},[(_vm.notifications.length === 0)?_c('div',{staticClass:"no-notifications"},[_vm._v("\n          "+_vm._s(_vm.$t('notifications.not-found'))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(notification,$index){return _c('notification-item',{key:$index,attrs:{"item":notification},on:{"seen":_vm.setSeen}})})],2),_vm._v(" "),_c('div',{staticClass:" text-center p-2 border-top"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.seeAll()}}},[_vm._v(_vm._s(_vm.$t('notifications.mark-all-as-read')))])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(697)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e7222c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("17a670c5", content, true, {});

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown:hover>.dropdown-menu[data-v-31e7222c]{display:block}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-lg.vue"],"names":[],"mappings":"AACA,gDACE,aAAe,CAChB","file":"nav-header-lg.vue","sourcesContent":["\n.dropdown:hover>.dropdown-menu[data-v-31e7222c] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block"},[_c('nav',{staticClass:"navbar navbar-expand-md navbar__lg  fixed-top "},[_c('div',{staticClass:"sm-w-100 d-flex order-1 order-md-2"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row align-items-center"},[_c('li',{staticClass:"nav-item d-flex align-items-center order-2 order-md-1"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item order-1 order-md-2 "},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown order-3 "},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-display":"static","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle"},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e(),_vm._v(" "),_c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse order-2 order-md-1 navbarSupportedContent",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_lg-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_lg-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")]):_c('a',{staticClass:"dropdown-item",attrs:{"href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")])],1)}),0):_vm._e()],1)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar__md d-none d-sm-block d-md-block d-lg-none"},[_c('nav',{staticClass:"navbar fixed-top"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"}),_vm._v(" "),_c('li',{staticClass:"nav-item d-flex align-items-center"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNavmd"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex "},[_c('ul',{staticClass:"navbar-nav mb-auto "},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect && navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mb-5"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":""}})])])}]


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(703)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de3b628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("6c98affe", content, true, {});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".navbar .nav-link[data-v-0de3b628]:focus{color:#cb2026}.flag-icon[data-v-0de3b628]{width:38px;height:38px}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-sm.vue"],"names":[],"mappings":"AACA,yCACE,aAAe,CAChB,AACD,4BACE,WAAY,AACZ,WAAa,CACd","file":"nav-header-sm.vue","sourcesContent":["\n.navbar .nav-link[data-v-0de3b628]:focus{\n  color: #cb2026;\n}\n.flag-icon[data-v-0de3b628] {\n  width: 38px;\n  height: 38px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar  d-flex align-items-center navbar__sm  fixed-top  d-block d-sm-none"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNav"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex justify-content-end flex-column h-100 "},[_c('ul',{staticClass:"navbar-nav mb-auto "},[_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap"},[_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/geo.svg","alt":""},on:{"click":function($event){return _vm.setLocale('ka')}}}),_vm._v(" "),_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/eng.svg","alt":""},on:{"click":function($event){return _vm.setLocale('en')}}})])])],2),_vm._v(" "),_vm._m(3)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",staticStyle:{"height":"19px !important"},attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":"close button"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ug-logo mx-auto"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])}]


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-header-lg',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-md',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-sm',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center mt-5 mt-sm-0"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(710)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e48c0c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(713)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211f040a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("d2b11102", content, true, {});

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"app-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header header top-header"},[_c('div',{staticClass:"container-fluid"},[_c('nav-header')],1)])}
var staticRenderFns = []


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("62111f00", content, true, {});

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"page-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-none d-sm-none d-md-block"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"page-leftheader"},[_c('page-title',{attrs:{"title":_vm.pageTitle}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var LabResource = /*#__PURE__*/function () {
  function LabResource() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LabResource);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LabResource, [{
    key: "units",
    value: function units() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/units');
    }
  }, {
    key: "loadUnit",
    value: function loadUnit(unitId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/units/' + unitId);
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(unitId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/lab/units/' + unitId);
    }
  }, {
    key: "loadCurrentExercise",
    value: function loadCurrentExercise(unitId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/units/' + unitId + '/current-exercise');
    }
  }, {
    key: "loadNextExercise",
    value: function loadNextExercise(unitId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/units/' + unitId + '/next-exercise');
    }
  }, {
    key: "loadResults",
    value: function loadResults(unitId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/units/' + unitId + '/results');
    }
  }, {
    key: "answer",
    value: function answer(unitId, exerciseId, answers) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/lab/units/' + unitId + '/answer/' + exerciseId, {
        answers: answers
      });
    }
  }, {
    key: "note",
    value: function note() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/lab/note');
    }
  }]);

  return LabResource;
}();



/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_header__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page_page_header__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_labResource__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lab_instruction__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lab_multiple_choice__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_lab_blank_question__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lab_true_false__ = __webpack_require__(1125);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var labResource = new __WEBPACK_IMPORTED_MODULE_3__api_labResource__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lab-unit',
  components: {
    TrueFalse: __WEBPACK_IMPORTED_MODULE_7__components_lab_true_false__["a" /* default */],
    BlankQuestion: __WEBPACK_IMPORTED_MODULE_6__components_lab_blank_question__["a" /* default */],
    MultipleChoice: __WEBPACK_IMPORTED_MODULE_5__components_lab_multiple_choice__["a" /* default */],
    Instruction: __WEBPACK_IMPORTED_MODULE_4__components_lab_instruction__["a" /* default */],
    sidebar: __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__["a" /* default */],
    appHeader: __WEBPACK_IMPORTED_MODULE_1__components_app_header__["a" /* default */],
    pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_page_page_header__["a" /* default */]
  },
  computed: {
    pageData: function pageData() {
      return {
        title: this.$t('lab.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false
        }, {
          icon: '',
          title: this.$t('lab.title'),
          link: '/lab',
          isActive: true
        }]
      };
    },
    statusBar: function statusBar() {
      var completedPercent = 0;

      if (this.exercise) {
        completedPercent = this.exercise.position / this.exercise.total_exercises * 100;
      }

      return parseInt(completedPercent);
    }
  },
  mounted: function mounted() {
    this.loadUnit();
    this.sendRequest(this.$route.params.unitId);
  },
  data: function data() {
    return {
      unit: null,
      session: null,
      canSendRequest: false,
      exercise: null,
      answers: [],
      finished: false,
      finishDate: '',
      totalPoint: 0,
      checked: false,
      loading: false,
      validatedAnswers: []
    };
  },
  watch: {
    session: function session(value) {
      if (value && value.request_approved_by) {
        this.loadCurrentExercise();
      } else if (value && !value.request_approved_by) {
        setTimeout(function () {
          window.location.reload();
        }, 10000);
      }
    }
  },
  methods: {
    getPoint: function getPoint() {
      return parseFloat(this.session.current_answers / this.unit.total_questions).toPrecision(2);
    },
    answerBlankQuestion: function answerBlankQuestion(questionId, answerId, value) {
      var answer = this.answers.find(function (o) {
        return o.answer_id == answerId && o.question_id == questionId;
      });

      if (answer) {
        answer.value = value;
      } else {
        this.answers.push({
          question_id: questionId,
          answer_id: answerId,
          value: value
        });
      }
    },
    answerMultiple: function answerMultiple(questionId, answerId) {
      var answer = this.answers.find(function (o) {
        return o.question_id == questionId;
      });

      if (answer) {
        answer.question_id = questionId;
        answer.answer_id = answerId;
      } else {
        this.answers.push({
          question_id: questionId,
          answer_id: answerId
        });
      }
    },
    answerTrueFalse: function answerTrueFalse(questionId, value) {
      var answer = this.answers.find(function (o) {
        return o.question_id == questionId;
      });

      if (answer) {
        answer.question_id = questionId;
        answer.answer_id = value;
      } else {
        this.answers.push({
          question_id: questionId,
          answer_id: value
        });
      }
    },
    handleCheckClick: function handleCheckClick() {
      if (this.exercise.questions.length === 0) {
        this.loadNextExercise();
        return;
      }

      if (this.validatedAnswers.length > 0) this.loadNextExercise();else this.answer();
    },
    answer: function answer() {
      var _this = this;

      this.loading = true;
      labResource.answer(this.unit.unitID, this.exercise.exerciseID, this.answers).then(function (response) {
        //this.exercise = response.data.data;
        //this.loadNextExercise();
        var data = response.data.data;
        _this.validatedAnswers = data.answers;
        _this.session.correct_answers = data.correct_answers;
      }).catch(function (error) {
        _this.helpers.notifyErrorMessage(error, true, _this.$t('lab.close'));
      }).finally(function () {
        _this.loading = false;
      });
    },
    exerciseLoaded: function exerciseLoaded(response) {
      if (response.data.data.finished) {
        this.finished = true;
        this.finishDate = response.data.data.finish_date;
        this.totalPoint = response.data.data.points;
      } else {
        this.exercise = response.data.data;
        this.answers = [];
      }
    },
    loadNextExercise: function loadNextExercise() {
      var _this2 = this;

      this.loading = true;
      labResource.loadNextExercise(this.unit.unitID).then(function (response) {
        _this2.exerciseLoaded(response);

        _this2.validatedAnswers = [];
      }).catch(function (error) {
        _this2.helpers.notifyErrorMessage(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    loadCurrentExercise: function loadCurrentExercise() {
      var _this3 = this;

      labResource.loadCurrentExercise(this.unit.unitID).then(function (response) {
        _this3.exerciseLoaded(response);

        _this3.loadResults();
      });
    },
    sendRequest: function sendRequest(unitID) {
      var _this4 = this;

      labResource.sendRequest(unitID).then(function (response) {
        _this4.session = response.data.data;

        _this4.notifySuccessMessage($t('lab.request-successfully-sent'));
      });
    },
    loadUnit: function loadUnit() {
      var _this5 = this;

      this.loading = true;
      labResource.loadUnit(this.$route.params.unitId).then(function (response) {
        _this5.unit = response.data.data.unit;
        _this5.session = response.data.data.session;
        _this5.canSendRequest = response.data.data.can_send;
      }).catch(function (error) {
        _this5.$router.push('/lab');
      }).finally(function () {
        _this5.loading = false;
      });
    },
    loadResults: function loadResults() {
      var _this6 = this;

      this.loading = true;
      labResource.loadResults(this.unit.unitID).then(function (response) {
        var data = response.data.data;
        _this6.validatedAnswers = data.answers;
        _this6.session.correct_answers = data.correct_answers;
      }).finally(function () {
        _this6.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'instruction',
  props: ['instructionText', 'instructionExercise']
});

/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiple-choice',
  props: ['question', 'index', 'validated-answers'],
  methods: {
    handleCheck: function handleCheck(questionId, answerId) {
      this.$emit('answer', questionId, answerId);
    },
    isValid: function isValid(questionId, answerId) {
      var answer = this.validatedAnswers.find(function (o) {
        return o.question_id == questionId;
      });
      return answer && answer.correct_answers.answerID == answerId ? true : false;
    },
    getIfAnswered: function getIfAnswered(questionId) {
      return this.validatedAnswers.find(function (o) {
        return o.question_id == questionId;
      });
    }
  }
});

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blank-question',
  props: ['question', 'index', 'validated-answers'],
  data: function data() {
    return {
      selected: null,
      inputs: []
    };
  },
  watch: {
    question: function question() {
      this.inputs = [];
    },
    validatedAnswers: function validatedAnswers(val) {
      var _iterator = _createForOfIteratorHelper(val),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          this.inputs[input.answer_id] = input.answer_text;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  methods: {
    correctAnswer: function correctAnswer($index) {
      if (this.getIfAnswered($index) && this.getIfAnswered($index).correct_answers) {
        return this.getIfAnswered($index).correct_answers[$index].answer;
      }

      return false;
    },
    getText: function getText() {
      return this.question.text.split('[]');
    },
    handleBlur: function handleBlur($index) {
      this.$emit('answer', this.question.questionID, $index, this.inputs[$index]);
    },
    isValid: function isValid($index) {
      var answer = this.getIfAnswered($index);
      return answer && answer.is_correct == 1;
    },
    getIfAnswered: function getIfAnswered($index) {
      return this.validatedAnswers.find(function (o) {
        return o.answer_id == $index;
      });
    }
  }
});

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'true-false',
  props: ['question', 'index', 'validated-answers'],
  data: function data() {
    return {
      answers: [{
        answer_id: 1,
        answer_text: 'True'
      }, {
        answer_id: 0,
        answer_text: 'False'
      }]
    };
  },
  methods: {
    handleCheck: function handleCheck(questionId, value) {
      this.$emit('answer', questionId, value);
    },
    isTrue: function isTrue(questionId) {
      return this.getIfAnswered(questionId).correct_answers == 1;
    },
    isValid: function isValid(questionId, answerId) {
      return answerId == this.isTrue(questionId);
    },
    getIfAnswered: function getIfAnswered(questionId) {
      return this.validatedAnswers.find(function (o) {
        return parseInt(o.question_id) === parseInt(questionId);
      });
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.40361b0f12238086554f.js